import type { TickSystem } from '@app-games/core';
import type { GameState } from '../state.js';
import type { GameAction } from '../actions.js';

export const roastingSystem: TickSystem<GameState, GameAction> = {
  name: 'roasting',
  update: (state, dt, _dispatch) => {
    if (!state.isRunning) return state;
    if (!state.roasting.active || state.roasting.result !== null) return state;

    const newHeat = Math.min(1, state.roasting.heatLevel + state.roasting.speed * dt);

    // Auto-fail if heat reaches 1.0
    if (newHeat >= 1) {
      return {
        ...state,
        roasting: { ...state.roasting, heatLevel: 1, result: 1 },
      };
    }

    return {
      ...state,
      roasting: { ...state.roasting, heatLevel: newHeat },
    };
  },
};
